import { render, staticRenderFns } from "./orderCgShddApprove.vue?vue&type=template&id=2ecc450b&scoped=true"
import script from "./orderCgShddApprove.vue?vue&type=script&lang=js"
export * from "./orderCgShddApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgShddApprove.vue?vue&type=style&index=0&id=2ecc450b&prod&scoped=true&lang=css"
import style1 from "./orderCgShddApprove.vue?vue&type=style&index=1&id=2ecc450b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc450b",
  null
  
)

export default component.exports